import { AxiosError } from 'axios';

/**
 * Returns true if the error is an Axios request-abort error.
 *
 * This typically happens when a React Query query is cancelled because the
 * component unmounted before the request completed. It is benign and should
 * NOT be propagated to an ErrorBoundary via `throwOnError`.
 */
export function isAbortError(error: unknown): boolean {
  if (!(error instanceof AxiosError)) {
    return false;
  }
  return error.code === 'ERR_CANCELED' || error.message === 'Request aborted';
}

/**
 * A `throwOnError` predicate for React Query that excludes aborted requests.
 *
 * Usage: `useQuery({ ..., throwOnError: throwUnlessAborted })`
 */
export function throwUnlessAborted(error: unknown): boolean {
  return !isAbortError(error);
}
